import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-magnify',
  templateUrl: './magnify.component.html',
  styleUrls: ['./magnify.component.css']
})
export class MagnifyComponent implements OnInit {
  constVal = 0
  constructor() { }

  @Input() imageId;
  @Input() ImageURL;

  ngOnInit(): void {
  }

  showmagnify() {
    let url=''
    this.magnify('uploadImg1', 3,url);
  }
  magnify(imgID, zoom,url) {
    imgID=this.imageId
    url=this.ImageURL
    this.constVal = this.constVal + 1
    //alert('hi')
    var ourImage = imgID;//new Image();
    ourImage = imgID;
    var img, glass, w, h, bw;
    if (this.constVal == 1) {
      img = document.getElementById(imgID);
      ourImage = img;
      /*create magnifier glass:*/
      glass = document.createElement('DIV');
      glass.setAttribute('class', 'img-magnifier-glass');
      /*insert magnifier glass:*/
      ourImage.parentElement.insertBefore(glass, ourImage);
      /*set background properties for the magnifier glass:*/
      glass.style.backgroundImage = "url('" + url + "')";
      glass.style.backgroundRepeat = 'no-repeat';
      glass.style.backgroundSize =
        ourImage.width * zoom + 'px ' + ourImage.height * zoom + 'px';
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;
      /*execute a function when someone moves the magnifier glass over the image:*/
      glass.addEventListener('mousemove', moveMagnifier);
      ourImage.addEventListener('mousemove', moveMagnifier);
      /*and also for touch screens:*/
      glass.addEventListener('touchmove', moveMagnifier);
      ourImage.addEventListener('touchmove', moveMagnifier);
      function moveMagnifier(e) {
        // alert('lllll')
        var pos, x, y;
        /*prevent any other actions that may occur when moving over the image*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        /*prevent the magnifier glass from being positioned outside the image:*/
        if (x > ourImage.width - w / zoom) {
          x = ourImage.width - w / zoom;
        }
        if (x < w / zoom) {
          x = w / zoom;
        }
        if (y > ourImage.height - h / zoom) {
          y = ourImage.height - h / zoom;
        }
        if (y < h / zoom) {
          y = h / zoom;
        }
        /*set the position of the magnifier glass:*/
        glass.style.left = x - w + 'px';
        glass.style.top = y - h + 'px';
        /*display what the magnifier glass "sees":*/
        //console.log(x + '---' + y + '---' +zoom)
        glass.style.backgroundPosition =
          '-' + (x * zoom - w + bw) + 'px -' + (y * zoom - h + bw) + 'px';
      }
      function getCursorPos(e) {
        var a,
          x = 0,
          y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = ourImage.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    }
  }
}
